import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiUser = () => {
 const { auth } = contextApp();

 const UserApi = axios.create({
  baseURL: urls.user(),
  headers: { 'x-access-token': auth?.token }
 });

 /* const getSetting = async (query = null) => (await SettingApi.get(`/${user}`, { params: query })).data; */

 const getUser = async id => (await UserApi.get(`/${id ? id : ''}`)).data;

 const updateUser = async newUser => (await UserApi.patch('/', newUser)).data;

 const createUser = async newUser => (await UserApi.post('/', newUser)).data;

 const deletUser = async id => (await UserApi.delete('/' + id)).data;

 return { getUser, createUser, updateUser, deletUser };
};
